import { ChartDataset, Plugin } from "chart.js";

import { ANALYSIS_DATA_TYPE } from "@/constants";

/**
 * Used to style branschindex differently from the other lines
 */

const STROKE_LENGTH = 30;
const STROKE_WIDTH = 2;
const PADDING = 5;
const FONT_SIZE = 14;

const IndexPlugin: Plugin<"line", IndexPluginOptions> = {
  id: "indexPlugin",
  install(chart, _args, { type }) {
    const datasets = chart.data.datasets as ChartDataset<"line">[];

    datasets.forEach((dataset) => {
      const data_type = dataset.data_type;
      if (data_type && type === data_type) {
        dataset.hidden = datasets.some(
          (d) => d.data_type === ANALYSIS_DATA_TYPE.ALL
        );
        dataset.borderDash = [5, 5];
        dataset.pointRadius = 0;
        dataset.pointHoverRadius = 0;
      }
    });
  },
  afterDatasetsDraw(chart, _args, { type }) {
    const datasetIndex = chart.data.datasets?.findIndex(
      (d) => d.data_type === type
    );
    const dataset = chart.data.datasets?.[datasetIndex];
    const hidden = chart.getDatasetMeta(datasetIndex).hidden;
    const { ctx, chartArea } = chart;

    // There's no index dataset
    if (!dataset || (hidden === null && dataset.hidden === true) || hidden)
      return;

    // Setup texts and colors
    const color = dataset?.backgroundColor as string;
    const text = dataset.label as string;

    ctx.font = `${FONT_SIZE}px`;
    ctx.strokeStyle = color;

    // Measure the text to know how to place it
    const measuredText = ctx.measureText(text);

    // Calculate where the line should start
    const lineX = chartArea.right - measuredText.width - PADDING;

    // Calculate where on Y the text should be placed
    const textY = chartArea.top - FONT_SIZE / 2;

    // Calculate where on Y the line should be placed
    const lineY = textY - FONT_SIZE / 4;

    // Draw the line
    ctx.beginPath();
    ctx.setLineDash([3, 5]);
    ctx.moveTo(lineX - STROKE_LENGTH, lineY);
    ctx.lineTo(lineX, lineY);
    ctx.lineWidth = STROKE_WIDTH;
    ctx.closePath();
    ctx.stroke();

    // reset dash
    ctx.setLineDash([]);

    // Draw the text
    ctx.fillStyle = color;
    ctx.fillText(text, chartArea.right - measuredText.width, textY);
  },
  defaults: {
    type: "branschindex",
  },
};

export type IndexPluginOptions = {
  type?: string;
};

export default IndexPlugin;
